"use strict";
/**
 * This file contains the constructor for the full tracker.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var schema_inspector_1 = __importDefault(require("schema-inspector"));
var addToCart_1 = __importDefault(require("./schemas/addToCart"));
var removeFromCart_1 = __importDefault(require("./schemas/removeFromCart"));
var order_1 = __importDefault(require("./schemas/order"));
var autoSearch_1 = __importDefault(require("./schemas/autoSearch"));
var search_1 = __importDefault(require("./schemas/search"));
var viewProduct_1 = __importDefault(require("./schemas/viewProduct"));
var impression_1 = __importDefault(require("./schemas/impression"));
var core_1 = require("./core");
/**
 * Sanitization schemas used to transform the data the customer calls the event sending functions with.
 */
var SCHEMAS = {
    addToCart: addToCart_1.default.sanitization,
    autoSearch: autoSearch_1.default.sanitization,
    impression: impression_1.default.sanitization,
    order: order_1.default.sanitization,
    removeFromCart: removeFromCart_1.default.sanitization,
    search: {
        sanitization: search_1.default.sanitization,
        validation: search_1.default.validation,
    },
    viewProduct: viewProduct_1.default.sanitization,
};
/**
 * Based on the schema provided, sanitize the event
 * @param event
 * @param sanitization
 */
var sanitizeEvent = function (event, sanitization) {
    schema_inspector_1.default.sanitize(sanitization, event);
};
// Full variant has sanitization and validation.
var GbTracker = core_1.TrackerCore(SCHEMAS, sanitizeEvent);
module.exports = GbTracker;
